import React from 'react';

import SearchSection from 'pages/Landings/sections/Home/components/SearchSection';
import TitleSection from 'pages/Landings/sections/Home/components/TitleSection';

import BlogSection from './components/BlogSection';
import ProductsSection from './components/ProductsSection';
import ResourcesSection from './components/ResourcesSection';
import SolutionsSection from './components/SolutionsSection';
import useStyles from './styles';

import Layout from '../../components/Layout';

const Home: React.FC = () => {
    const { classes } = useStyles();
    return (
        <Layout>
            <SearchSection className={classes.search} />
            <TitleSection className={classes.title} />
            <ProductsSection className={classes.section} />
            <SolutionsSection className={classes.section} />
            <ResourcesSection className={classes.section} />
            <BlogSection className={classes.section} />
        </Layout>
    );
};

export default Home;
